// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2H2jz","label":"SetPasswdForm_label__2FPRr"};